var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 36C0 16.1169 16.1169 0 36 0C55.8831 0 72 16.1169 72 36C72 55.8831 55.8831 72 36 72C16.1169 72 0 55.8831 0 36ZM51.7809 32.3705C52.4277 32.7305 52.9666 33.2567 53.3417 33.8949C53.7168 34.533 53.9147 35.2598 53.9147 36C53.9147 36.7402 53.7168 37.467 53.3417 38.1051C52.9666 38.7433 52.4277 39.2695 51.7809 39.6295L31.0929 51.1237C30.4608 51.4746 29.748 51.6544 29.025 51.6454C28.302 51.6363 27.5939 51.4388 26.9707 51.0722C26.3476 50.7055 25.8309 50.1826 25.4717 49.5551C25.1126 48.9276 24.9235 48.2172 24.9231 47.4942V24.5058C24.9231 21.3415 28.3237 19.3366 31.0929 20.8763L51.7809 32.3705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ae9bd307dc94c9d808e210f800839ca6.svg";
export { ForwardRef as ReactComponent };